import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useGroupsStore from '../../stores/groupsStore';
import useStudentsStore from '../../stores/studentsStore';
import Sidebar from '../../components/Admin/Sidebar';
import AdminHeader from '../../components/Admin/AdminHeader';
import AdminSchedule from '../../components/Admin/AdminSchedule';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

function AdminGroupFull() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getGroup, updateGroup, deleteGroup } = useGroupsStore();
  const { getStudentsWithoutGroup, updateStudent, fetchStudents } = useStudentsStore();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [newName, setNewName] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [studentsToAdd, setStudentsToAdd] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showSchedule, setShowSchedule] = useState(false);

  useEffect(() => {
    fetchGroup();
    fetchStudents();
    // eslint-disable-next-line
  }, [id]);

  async function fetchGroup() {
    setLoading(true);
    try {
      const data = await getGroup(id);
      setGroup(data);
      setNewName(data.name);
    } catch {
      setGroup(null);
    } finally {
      setLoading(false);
    }
  }

  async function handleEditName() {
    setActionLoading(true);
    setError(null);
    try {
      await updateGroup(id, { name: newName });
      setEditMode(false);
      await fetchGroup();
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  async function handleDelete() {
    if (!window.confirm('Удалить группу?')) return;
    setActionLoading(true);
    setError(null);
    try {
      await deleteGroup(id);
      navigate('/admin/groups');
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  async function openAddModal() {
    setShowAddModal(true);
    setActionLoading(true);
    setError(null);
    try {
      const { students } = useStudentsStore.getState();
      
      const availableStudents = students.filter(student => {
        if (Array.isArray(student.groups)) {
          const isInGroup = student.groups.some(g => String(g._id || g) === String(id));
          return !isInGroup;
        }
        if (student.group) {
          return String(student.group._id || student.group) !== String(id);
        }
        return true;
      });
      
      setStudentsToAdd(availableStudents);
      setSelectedStudent(availableStudents[0]?._id || '');
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  async function handleAddStudent(e) {
    e.preventDefault();
    if (!selectedStudent) return;
    setActionLoading(true);
    setError(null);
    try {
      const currentStudent = studentsToAdd.find(s => s._id === selectedStudent);
      if (!currentStudent) {
        throw new Error('Ученик не найден');
      }

      let newGroups = [];
      if (Array.isArray(currentStudent.groups)) {
        newGroups = [...currentStudent.groups];
        const groupExists = newGroups.some(g => String(g._id || g) === String(id));
        if (!groupExists) {
          newGroups.push(id);
        }
      } else if (currentStudent.group) {
        newGroups = [currentStudent.group._id || currentStudent.group, id];
      } else {
        newGroups = [id];
      }

      await updateStudent(selectedStudent, { groups: newGroups });
      setShowAddModal(false);
      await fetchGroup();
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  return (
    <div className='AdminGroupFull'>
      <div className="AdminGroupFull__container">
        <Sidebar className="admin-sidebar" />
        <div className="content_admin">
          {loading && <div>Загрузка...</div>}
          {!loading && group && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
                {editMode ? (
                  <>
                    <input value={newName} onChange={e => setNewName(e.target.value)} style={{ fontSize: 20, padding: 6, borderRadius: 6, border: '1px solid #ccc' }} />
                    <button onClick={handleEditName} disabled={actionLoading} style={{ background: '#4c20bb', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontWeight: 500, cursor: 'pointer' }}>Сохранить</button>
                    <button onClick={() => { setEditMode(false); setNewName(group.name); }} style={{ background: '#f5f5f5', border: '1px solid #ccc', borderRadius: 6, padding: '6px 16px', cursor: 'pointer' }}>Отмена</button>
                  </>
                ) : (
                  <>
                    <h2 style={{ margin: 0 }}>{group.name}</h2>
                    <button onClick={() => setEditMode(true)} style={{ background: '#4c20bb', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontWeight: 500, cursor: 'pointer' }}>Редактировать</button>
                    <button onClick={handleDelete} disabled={actionLoading} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontWeight: 500, cursor: 'pointer' }}>Удалить</button>
                  </>
                )}
              </div>
              <div style={{ marginBottom: 20, fontSize: 16 }}><b>Кол-во обучающихся:</b> {group.students ? group.students.length : 0}</div>
              <div style={{ marginBottom: 20 }}>
                <button onClick={openAddModal} style={{ background: '#6c3be4', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 500, fontSize: 16, cursor: 'pointer' }}>Добавить ученика</button>
                <button onClick={() => setShowSchedule(v => !v)} style={{ background: '#4c20bb', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 500, fontSize: 16, cursor: 'pointer', marginLeft: 12 }}>{showSchedule ? 'Скрыть расписание' : 'Расписание группы'}</button>
                <button onClick={() => navigate(`/admin/groups/${id}/attendance`)} style={{ background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 500, fontSize: 16, cursor: 'pointer', marginLeft: 12 }}>Посещаемость группы</button>
              </div>
              {showSchedule && <div style={{ margin: '32px 0' }}><AdminSchedule groupId={group._id} /></div>}
              <div style={{ marginBottom: 16, fontWeight: 500 }}>Список учеников:</div>
              <div style={{ background: '#f7f7f9', borderRadius: 8, padding: 12, minHeight: 60 }}>
                {group.students && group.students.length > 0 ? group.students.map(s => (
                  <div key={s._id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #ece9f7' }}>
                    <span>{s.fullName}</span>
                    <div style={{display: 'flex', gap: 10}}>
                      <button
                        style={{ background: '#4c20bb', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer' }}
                        onClick={() => navigate(`/admin/user/${s._id}/full`)}
                      >
                        Подробнее
                      </button>
                      <button
                        style={{ background: '#e67e22', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', cursor: 'pointer', fontWeight: 500, fontSize: 15, transition: 'background 0.2s' }}
                        onClick={async () => {
                          if (!window.confirm('Удалить этого ученика из группы?')) return;
                          setActionLoading(true);
                          setError(null);
                          try {
                            // Получаем текущего ученика для обновления его групп
                            const { students } = useStudentsStore.getState();
                            const currentStudent = students.find(student => String(student._id) === String(s._id));
                            
                            if (!currentStudent) {
                              throw new Error('Ученик не найден');
                            }

                            // Формируем новый массив групп без текущей группы
                            let newGroups = [];
                            if (Array.isArray(currentStudent.groups)) {
                              newGroups = currentStudent.groups.filter(g => String(g._id || g) !== String(id));
                            } else if (currentStudent.group && String(currentStudent.group._id || currentStudent.group) !== String(id)) {
                              // Если есть старое поле group и это не текущая группа, сохраняем его
                              newGroups = [currentStudent.group._id || currentStudent.group];
                            }
                            // Если newGroups пустой, ученик будет без групп

                            // Обновляем ученика с новым массивом групп
                            const updatedStudent = await updateStudent(s._id, { groups: newGroups });
                            
                            // Обновляем данные группы и студентов
                            await fetchGroup();
                            await fetchStudents();
                          } catch (e) {
                            setError(e.message);
                          } finally {
                            setActionLoading(false);
                          }
                        }}
                        disabled={actionLoading}
                        onMouseOver={e => e.currentTarget.style.background = '#d35400'}
                        onMouseOut={e => e.currentTarget.style.background = '#e67e22'}
                      >
                        Удалить из группы
                      </button>
                    </div>
                  </div>
                )) : <div style={{ color: '#888' }}>Нет учеников</div>}
              </div>
              {error && <div style={{ color: 'red', marginTop: 16 }}>{error}</div>}
            </>
          )}
          {!loading && !group && <div style={{ color: 'red' }}>Группа не найдена</div>}
        </div>
      </div>
      {showAddModal && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="modal-content" style={{ position: 'relative', background: '#fff', borderRadius: 12, padding: 32, minWidth: 320, maxWidth: 400 }}>
            {/* Крестик закрытия */}
            <button onClick={() => setShowAddModal(false)} style={{ position: 'absolute', top: 12, right: 16, background: 'transparent', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }} aria-label="Закрыть">×</button>
            <h3 style={{ marginBottom: 20 }}>Добавить ученика в группу</h3>
            {actionLoading && <div>Загрузка...</div>}
            {!actionLoading && studentsToAdd.length === 0 && <div style={{ color: '#888' }}>Нет свободных учеников</div>}
            {!actionLoading && studentsToAdd.length > 0 && (
              <form onSubmit={handleAddStudent}>
                <select value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)} style={{ width: '100%', marginBottom: 16, padding: 8, borderRadius: 6, border: '1px solid #ccc' }}>
                  {studentsToAdd.map(s => <option value={s._id} key={s._id}>{s.fullName}</option>)}
                </select>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                  <button type="button" onClick={() => setShowAddModal(false)} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #ccc', background: '#f5f5f5' }}>Отмена</button>
                  <button type="submit" style={{ padding: '6px 16px', borderRadius: 6, background: '#6c3be4', color: '#fff', border: 'none' }}>Добавить</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
      <AdminBottomNavBar />
    </div>
  );
}

export default AdminGroupFull; 